/**
 * @Author: ikoros
 * @Date:   2020-04-08T23:11:52+08:00
 * @Last modified by:   ikoros
 * @Last modified time: 2020-05-04T16:34:41+08:00
 */

import 'whatwg-fetch';
import reqwest from 'reqwest';

import moment from 'moment';

export const baseUrl = '/education-jxcp-service-web/';

//export const url = "http://127.0.0.1:9999/video/";

// export const url = "http://zg.cua.edu.cn/video/";
export const ciqaimages = "http://www.ciqa.org.cn/video/"
export const url = "http://www.ciqa.org.cn/video/"
// export const url = "http://101.200.140.124/video";

const headers = {
    'Content-Type': 'application/json'
};

import * as session from './../utils/session';
import menu from './../utils/menu';

/**
* @member POST请求
* @return Promise<any>
*/
const post = (url, params = {}) => fetch(baseUrl + url, {
    method: "POST",
    headers: headers,
    credentials: 'include',
    body: JSON.stringify(params)
})
.then(response => response.json())
.then(response=> {
    return response;
});;

/**
* @member GET请求
* @return Promise<any>
*/
const get = url => fetch(baseUrl + url, {
    headers: headers,
    credentials: 'include',
})
.then(response => response.json())
.then(response=> {
    return response;
});

const transform = (response) => {
    const data = response.payload.data;
    return {
        success: true,
        code: response.code,
        message: response.message,
        payload: {
        account: {
            id: data.employeeId,
            loginName: data.loginName,
            realName: data.realName,
            schoolName: data.schoolName,
            termName: data.termName,
            yearName: data.yearName,
            termId: data.termId,
            yearId: data.yearId,
            dudao: data.dudao,
            systemName: data.systemName
        },
        rules: data.roleModuleList.map((rule) => {
            return {
                id: rule.id,
                name: rule.name,
                pid: rule.pid,
                url: rule.url,
                depth: rule.level,
                icon: rule.icon,
                label: rule.label,
                orderNum: rule.orderNum
            }
        }),
        roleIds: data.roleIds,
        operationList: data.operationList,
        show: data.display
        }
    };
}

const saveSession = (data) => {
    var result = menu(data.payload.rules);
    const operation = {};

    data.payload.operationList.forEach(item => {
        operation[item.operationUrl] = {
            name: item.operationName,
            enabled: item.enabled,
            show: data.payload.show
        }
    });
    
    return {
        account: data.payload.account,
        rules: result[0].children,
        roleIds: data.payload.roleIds,
        operation: operation
    };
}

/**
 * @method 登录
 * @param {object} domain
 * @return {promise}
 */
export const login = (domain) => {
   return Promise.all([ getIndexInfo() ,post('employee/login', domain)]).then(
        response  => {
            return new Promise((resolve, reject ) => {
                const indexInfo = response[0];
                const loginInfo = response[1];
                if(indexInfo.code === 200 && loginInfo.code === 200) {
                    sessionStorage.setItem('website', JSON.stringify(indexInfo.payload.data))
                    resolve(saveSession(transform(loginInfo)));
                } else {
                    reject({message: loginInfo.message});
                }
            })
        }
   )

    // return post('employee/login', domain).then(response  => {
    //     return new Promise((resolve, reject ) => {


    //         if(response.code === 200) {
    //             resolve(saveSession(transform(response)));
    //         } else {
    //             reject({message: response.message});
    //         }
    //     })
    // });
}

/**
 * @method 退出
 * @param {object} domain
 * @return {promise}
 */
export const logout = (options) => {
    return post('employee/logout', {});
}

/**
 * @method 获取菜单信息
 * @return {promise}
 */
export const getMenuList = () => {
    return post('/ciqafolder/front/tree', {})
    .then(response => response.payload.data).then(data => {
        return data.map(item => ({
            id: item.id,
            pid: item.pid,
            label: item.label,
            isHot : item.isHot,
            orderNum: item.orderNum
        }))
    }).then(data => {
        return menu(data)[0].children;
    });
}

export const getPiaochuang = () => {
    return get('/ciqapiaochuang/get/front')
    .then(response => response.payload.data);
}

/**
 * @method 根据手机号查询用户信息
 * @param {number} id
 * @return {promise}
 */
export const getIsView = (data) => {
    return get('/ciqafile/isview/'+ data.id, {})
    .then(response => response.payload.data);
}

/**
 * @method 根据手机号查询用户信息
 * @param {number} id
 * @return {promise}
 */
export const getAttachmentList = (data) => {
    return post('/ciqafile/attachmentlist/', {
        pid: data.id,
        pageSize: 100,
        pageNum: 1
    })
    .then(response => response.payload.data).then(data => {
        return data.dataList.map(item => ({
            id: item.id,
            title: item.name
        }))
    });
}

/**
 * @method 根据手机号查询用户信息
 * @param {number} id
 * @return {promise}
 */
export const getNewsList = () => {
    return get('/applyrecord/getstatus', {})
    .then(response => response.payload.data);
}

/**
 * @method 获取Tags
 * @param {JSON} params
 * @return {promise}
 */
export const getArticleTags = (params) => {
    return post('/platform/code/ciqafilelabel', params)
    .then(response => response.payload.data);
}

/**
 * @method 获取文章列表
 * @param {JSON} params
 * @return {promise}
 */
export const getArticleList = (params) => {
    return post(`ciqafile/queryarticle?pageNum=${params.pageNum}&pageSize=${params.pageSize}&sort=publishDate&order=desc`, {
        "catetoryId": params.categoryId
    })
    .then(response => response.payload.data).then(data => {
        return {
            pageNum: data.pageNum,
            pageSize: data.pageSize,
            total: data.total,
            result: data.dataList.map(item => ({
                id: item.id,
                name: item.name,
                title : item.title,
                fullPath : item.fullPath,
                type: item.fileFormat,
                fileType : item.fileType,
                viewType : item.viewType,
                publishDate: moment(new Date(item.publishDate)).format('MM-DD')
            }))
        }
    });
}

/**
 * @method 根据Id获取文章
 * @param {number} id
 * @return {promise}
 */
export const getArticleById = (id) => {
    return get(''+ id, {})
    .then(response => response.payload.data);
}

/**
 * @method 用户信息
 * @param {number} id
 * @return {promise}
 */
export const getUserInfo = (id) => {
    return get('clouduser/get', {})
    .then(response => response.payload.data);
}

/**
 * @method 注册信息
 * @param {number} id
 * @return {promise}
 */
export const getUserApplyRecord = () => {
    return get('applyrecord/getuserapplyrecord', {})
    .then(response => response.payload.data);
}

/**
 * @method 后台首页信息
 * @return {promise}
 */
export const getIndexInfo = () => {
    return get('index', {})
    .then(response => response);
}

/**
 * @method 发布文章
 * @param {number} id
 * @return {promise}
 */
export const Insert = (formData) => {
    return new Promise((resolve, reject ) => {
        reqwest({
            url: `${baseUrl}/ciqafile/upload`,
            method: 'post',
            processData: false,
            data: formData,
            success: (response) => {
                resolve(response);
            },
            error: (response) => {
                reject(response);
            }
        });
    })
}
